import styled from 'styled-components'
import { COLORS } from '../../styles/theme'
import config from '../../config'

export const StyledLandingPage = styled.div`
  background: url(${config.assets.landing.portrait});
  background-size: cover;
  background-position: 50% 50%;
  height: calc(100% - 60px);
  width: 100vw;
  overflow-y: scroll;
  position: absolute;
  .directory {
    display: block;
    flex-direction: column;
    justify-content: center;
  }
  .smithNephew {
    position: fixed;
    bottom: 67%;
    left: 30%;
    right: 35%;
    cursor: pointer;

    .logo-container {
      display: flex;
      justify-content: center;
      img {
        width: 100%;
      }
    }
  }

  .malex-1 {
    position: fixed;
    bottom: 53%;
    left: 30%;
    right: 34%;
    cursor: pointer;
  
    .logo-container {
      display: flex;
      justify-content: center;
      img {
        width: 100%;
      }
    }
  }

  .malex-2 {
    position: fixed;
    bottom: 37%;
    top: 54%;
    left: 30%;
    right: 34%;
    cursor: pointer;
   
    .logo-container {
      display: flex;
      justify-content: center;
      img {
        width: 100%;
      }
    }
  }
`

export const StyledTheatre = styled.div`
  background: url(${config.assets.theatre.portrait});
  background-size: cover;
  background-position: 50% 50%;
  height: calc(100% - 60px);
  width: 100vw;
  overflow-y: scroll;
  position: absolute;
  .center-tv-container {
    /* border: 1px solid red; */
    position: absolute;
    top: 8%;
    left: 6%;
    right: 6%;
    bottom: 58%;
    iframe {
      height: 100%;
      width: 100%;
    }
    img {
      width: 100%;
    }
  }

  .return-button {
    position: absolute;
    bottom: 15%;
    text-decoration: none;
    background: linear-gradient(#ff9821, #f65148, #f22f5b);
    color: ${COLORS.hotButtonText};
    border-radius: 32px;
    border: 2px solid #ff9821;
    padding: 8px 0px;
    text-align: center;
    box-shadow: 0px 5px 4px -4px #000;
    left: 8%;
    right: 8%;
    cursor: pointer;
    p {
      font-size: 12px;
      margin: 0 auto;
    }
  }
`
